import { createContext } from 'react';
export var AIEventsInstrumentationContext = /*#__PURE__*/createContext(null);